import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer style={{ backgroundColor: '#fbefdaff', color: '#1d1d1d', padding: '4rem 0 2rem 0', marginTop: 'auto' }}>
      <div className="container" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '2rem', marginBottom: '3rem' }}>
        {/* Column 1 */}
        <div>
          <h3 style={{ fontFamily: 'var(--font-sans)', fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '1.5rem', color: '#7c2d12' }}>Adventure</h3>
          <p style={{ fontSize: '0.9rem', color: '#92400e', lineHeight: '1.6', maxWidth: '250px' }}>
            Explore the world's most pristine natural habitats and epic adventures.
          </p>
        </div>

        {/* Column 2 */}
        <div>
          <h3 style={{ fontFamily: 'var(--font-sans)', fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '1.5rem', color: '#7c2d12' }}>Quick Links</h3>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
            <li><Link to="/" style={{ color: '#92400e', fontSize: '0.9rem', textDecoration: 'none' }}>{t('nav.home')}</Link></li>
            <li><Link to="/wildlife" style={{ color: '#92400e', fontSize: '0.9rem', textDecoration: 'none' }}>{t('nav.wildlife')}</Link></li>
            <li><Link to="/trekking" style={{ color: '#92400e', fontSize: '0.9rem', textDecoration: 'none' }}>{t('nav.trekking')}</Link></li>
            <li><Link to="/stories" style={{ color: '#92400e', fontSize: '0.9rem', textDecoration: 'none' }}>{t('nav.stories')}</Link></li>
          </ul>
        </div>

        {/* Column 3 */}
        <div>
          <h3 style={{ fontFamily: 'var(--font-sans)', fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '1.5rem', color: '#7c2d12' }}>Support</h3>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
            <li><Link to="/about" style={{ color: '#92400e', fontSize: '0.9rem', textDecoration: 'none' }}>About Us</Link></li>
            <li><Link to="/faq" style={{ color: '#92400e', fontSize: '0.9rem', textDecoration: 'none' }}>FAQ</Link></li>
            <li><Link to="/terms" style={{ color: '#92400e', fontSize: '0.9rem', textDecoration: 'none' }}>Terms & Conditions</Link></li>
            <li><Link to="/privacy" style={{ color: '#92400e', fontSize: '0.9rem', textDecoration: 'none' }}>Privacy Policy</Link></li>
          </ul>
        </div>

        {/* Column 4 */}
        <div>
          <h3 style={{ fontFamily: 'var(--font-sans)', fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '1.5rem', color: '#7c2d12' }}>Follow Us</h3>
          <div style={{ display: 'flex', gap: '1rem' }}>
            <a href="#" style={{ color: '#92400e', transition: 'color 0.2s' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
            </a>
            <a href="#" style={{ color: '#92400e', transition: 'color 0.2s' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
            </a>
            <a href="#" style={{ color: '#92400e', transition: 'color 0.2s' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"></path></svg>
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="container">
        <div style={{ borderTop: '1px solid #f6c87a', paddingTop: '2rem', textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          <p style={{ fontSize: '0.85rem', color: '#92400e', margin: 0 }}>
            © 2026 SUNSHINE TRAVELS. {t('footer.rights')}
          </p>
          <p style={{ fontSize: '0.75rem', color: '#b45309', margin: 0 }}>
            <a href="https://datavex.ai/" target="_blank" rel="noopener noreferrer" style={{ color: '#b45309', textDecoration: 'none', fontWeight: 600 }}>
              {t('footer.powered_by')}
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
